import CompetitiveInt from './Competitive_int';

export default CompetitiveInt;
